import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-bottom: 2rem;

  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  @media only screen and (min-width: 768px) {
    margin-bottom: 3.5rem;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20vw;

  white-space: normal;
  padding: 0 0.5rem;

  @media only screen and (min-width: 768px) {
    padding: 0 2rem;
  }
`;

export const StepTexto = styled.p`
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.1rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.PRIMARY};
  margin-top: 0.9rem;

  span#date {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    font-size: 0.6rem;
    line-height: 0.754rem;
  }

  @media only screen and (min-width: 768px) {
    font-size: 1.6rem;
    line-height: 2.011rem;
    letter-spacing: 0em;

    span#date {
      font-size: 1.2rem;
      line-height: 1.508rem;
    }
  }
`;

export const StatusTitulo = styled.h3`
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.PRIMARY};

  margin: 3.5rem 0 3rem;

  @media only screen and (min-width: 768px) {
    font-size: 2.2rem;
    line-height: 2.765rem;
    letter-spacing: 0em;
  }
`;

export const CircleBorder = styled.div`
  border-radius: 50%;
  height: 1.6rem;
  width: 1.6rem;
  background-color: transparent;

  border: 1px solid ${({ theme }) => theme.colors.PRIMARY};
  padding: 3px;

  div {
    height: 100%;
    width: 100%;

    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.PRIMARY};
  }
`;
